import React, { useState } from 'react'
import { Card, DatePicker, FloatButton, Input, Pagination, Space, Spin } from 'antd';
import { deleteClientAbonement, getAbonementsClient, getClientTrainings, getClientsList } from 'src/store/Slices/ClientsSlice';
import { useDispatch } from 'react-redux';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { formateDate } from 'src/components/helpers/formateDate';
import SureModal from 'src/components/Modals/SureModal';
import { openNotification } from 'src/components/helpers/notification'
import EditTrainingModal from '../Modals/EditTrainingModal';
import UserModal from '../Modals/UserModal';
import AddClient from '../Modals/AddClient';

const { RangePicker } = DatePicker;

const MobileClientsPage = ({
    clients,
    abonements,
    getClientTrainingsList,
    clientsLoading,
    abonementsLoading
}) => {

    // HELPERS
    const dispatch = useDispatch()

    // STATE
    const [flag, setFlag] = useState('Клиент')
    const [page, setPage] = useState(1)
    const [clientInfo, setClientInfo] = useState()
    const [abonementInfo, setAbonementInfo] = useState()
    const [trainingInfo, setTrainingInfo] = useState()
    const [isDeletedModal, setIsDeletedModal] = useState(false)
    const [isTrainingModal, setIsTrainingModal] = useState(false)
    const [isClientModal, setIsClientModal] = useState(false)

    // FUNC
    const onClickDelete = () => {
        if (flag === 'Абонементы') {
            dispatch(deleteClientAbonement({
                clientId: clientInfo.id,
                abonementClubId: abonementInfo.abonementClubId
            })).then(() => {
                dispatch(getAbonementsClient({ clientId: clientInfo.id }))
                setIsDeletedModal(false)
                openNotification({
                    type: 'success',
                    message: `Абонемент успешно удален`
                })
            })
        }
    }

    // EFFECTS
    useEffect(() => {
        setPage(1)
    }, [flag])

    return (
        <>
            <AddClient
                visibleAddClient={isClientModal}
            />
            <SureModal
                visible={isDeletedModal}
                setVisible={setIsDeletedModal}
                onClickYes={onClickDelete}
            />
            <EditTrainingModal
                visible={isTrainingModal}
                setVisible={setIsTrainingModal}
                trainingInfo={trainingInfo}
                clientInfo={clientInfo}
            />
            <UserModal
                clientModal={isClientModal}
                setClientModal={setIsClientModal}
                clientInfo={clientInfo}
            />
            <Space style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} direction="vertical">
            {/* { flag === 'Клиент' && <Card title={`Фильтры (В разработке)`}
                    style={{ width: 330, marginTop: 16 }}
                >
                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        <div>
                            <div>№:</div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Input
                                    placeholder='От'
                                />
                                <Input
                                    placeholder='До'
                                />
                            </div>
                        </div>
                        <div>
                            <div>Дата рождения:</div>
                            <RangePicker />
                        </div>
                        <div>
                            <div>Поиск:</div>
                            <Input placeholder='Найти' />
                        </div>
                    </div>
                </Card>} */}
                <Pagination
                    defaultCurrent={page}
                    pageSize={20}
                    showSizeChanger={false}
                    current={page}
                    onChange={(page, pageSize) => {
                        setPage(page)
                        if (flag === 'Клиент') {
                            dispatch(getClientsList({
                                count: pageSize,
                                offset: pageSize * (page - 1)
                            }))
                        } else if (flag === 'Абонементы') {
                            dispatch(getAbonementsClient({
                                clientId: clientInfo.id,
                                count: pageSize,
                                offset: pageSize * (page - 1)
                            }))
                        }
                    }}
                    total={flag === 'Клиент' ? clients?.totalCount : flag === 'Абонементы' && abonements?.totalCount}
                    page={page}
                />
                {(flag === 'Клиент') && clients?.rows.map((element) => {
                    return (
                        <Card
                            loading={clientsLoading}
                            title={`Клиент №: ${element.id}`}
                            extra={<a href="#" onClick={() => {
                                setClientInfo(element)
                                setIsClientModal(true)
                            }}>Изменить</a>}
                            style={{ width: 330, marginTop: 16 }}
                            actions={[
                                <div onClick={() => {
                                    setClientInfo(element)
                                    dispatch(getAbonementsClient({ clientId: element.id }))
                                    setFlag('Абонементы')
                                }}>Абонементы</div>,
                                <div onClick={() => {
                                    setClientInfo(element)
                                    setFlag('Тренировки')
                                    dispatch(getClientTrainings({ clientId: element.id }))
                                }}>Тренировки</div>,
                            ]}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>№:</div>
                                    <div>Номер телефона:</div>
                                    <div>Почта:</div>
                                    <div>Фамилия:</div>
                                    <div>Имя:</div>
                                    <div>Отчество:</div>
                                    <div>Дата рождения:</div>
                                </div>
                                <div>
                                    <div>{element?.id ? element?.id : '-'}</div>
                                    <div>{element?.phoneNumber ? element?.phoneNumber : '-'}</div>
                                    <div>{element?.eMail ? element?.eMail : '-'}</div>
                                    <div>{element?.clientF ? element?.clientF : '-'}</div>
                                    <div>{element?.clientI ? element?.clientI : '-'}</div>
                                    <div>{element?.clientO ? element?.clientO : '-'}</div>
                                    <div>{element?.birthday ? formateDate(element?.birthday) : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
                {flag === 'Абонементы' && abonements?.rows.map((element) => {
                    return (
                        <Card
                            title={`Абонемент №: ${element.id}`}
                            extra={<a href='#' onClick={() => {
                                setAbonementInfo(element)
                                setIsDeletedModal(true)
                            }}>Удалить</a>}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                            loading={abonementsLoading}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>№:</div>
                                    <div>Клуб:</div>
                                    <div>Абонемент:</div>
                                    <div>Абонемент С:</div>
                                    <div>Абонемент До:</div>
                                    <div>Заморожен до:</div>
                                    <div>Заморожен:</div>
                                    <div>Дней заморозки:</div>
                                </div>
                                <div>
                                    <div>{element?.id ? element?.id : '-'}</div>
                                    <div>{element?.clubName ? element?.clubName : '-'}</div>
                                    <div>{element?.abonementName ? element?.abonementName : '-'}</div>
                                    <div>{element?.abonementFrom ? formateDate(element?.abonementFrom) : '-'}</div>
                                    <div>{element?.abonementTo ? formateDate(element?.abonementTo) : '-'}</div>
                                    <div>-</div>
                                    <div>{element?.isFrozen ? element?.isFrozen : '-'}</div>
                                    <div>{element?.frostUse ? element?.frostUse : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
                {flag === 'Тренировки' && getClientTrainingsList?.rows.map((element) => {
                    return (
                        <Card
                            title={`Тренировка №: ${element.id}`}
                            extra={<a onClick={() => {
                                setTrainingInfo(element)
                                setIsTrainingModal(true)
                            }} href="#">Изменить</a>}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>№:</div>
                                    <div>Наименование:</div>
                                    <div>Персональная:</div>
                                    <div>Осталось:</div>
                                    <div>Действует С:</div>
                                    <div>Действует До:</div>
                                </div>
                                <div>
                                    <div>{element?.id ? element?.id : '-'}</div>
                                    <div>{element?.name ? element?.name : '-'}</div>
                                    <div>{element?.isPersonal ? "Да" : 'Нет'}</div>
                                    <div>{element?.trainingsLeft ? element?.trainingsLeft : '-'}</div>
                                    <div>{element?.startDate ? formateDate(element?.startDate) : '-'}</div>
                                    <div>{element?.endDate ? formateDate(element?.endDate) : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
            </Space>
            {(flag === 'Абонементы' || flag === 'Клиент') && <FloatButton style={{ right: 24 }} type="primary" icon={<PlusOutlined />} onClick={() => {
                if (flag === 'Клиент') {
                    setIsClientModal(true)
                }
            }} />}
            {(flag === 'Абонементы' || flag === 'Тренировки') && <FloatButton style={{ bottom: 124 }} type="primary" icon={<CloseOutlined />} onClick={() => setFlag('Клиент')} />}
        </>
    )
}

export default MobileClientsPage